/*!
 * Purifier landing page – carousels + smooth scroll.
 * Replaces the Funnelish runtime. Uses Swiper 11 (mobile review slider),
 * jQuery + Owl Carousel 2 (desktop review slider) from the same CDNs as the original page.
 */
(function () {
  'use strict';

  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11.2.10/swiper-bundle.min.js';
  var JQUERY_JS = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/2.2.2/jquery.min.js';
  var OWL_JS = 'https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.1.3/owl.carousel.min.js';

  function loadScript(src, isReady, done) {
    if (isReady()) { done(); return; }
    var s = document.createElement('script');
    s.src = src;
    s.async = false;
    s.onload = done;
    s.onerror = function () { if (window.console) console.warn('Could not load ' + src); };
    document.head.appendChild(s);
  }

  /* ---- Swiper (mobile "what customers say" slider) ---- */
  function initSwiper() {
    if (!document.querySelector('.swiper_mobie_new07')) return;
    loadScript(SWIPER_JS, function () { return typeof window.Swiper !== 'undefined'; }, function () {
      var swiper = new window.Swiper('.swiper_mobie_new07', {
        loop: true,
        speed: 660,
        slidesPerView: 1.2,
        spaceBetween: -5,
        centeredSlides: true,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination-mobie-new',
          clickable: true
        }
      });
      swiper.slideNext();
    });
  }

  /* ---- Owl Carousel (desktop review slider) ---- */
  function initOwl() {
    if (!document.querySelector('.owl-carousel')) return;
    loadScript(JQUERY_JS, function () { return !!window.jQuery; }, function () {
      loadScript(OWL_JS, function () { return !!(window.jQuery && window.jQuery.fn.owlCarousel); }, function () {
        window.jQuery('.owl-carousel').owlCarousel({
          loop: true,
          margin: 10,
          nav: true,
          navText: [
            "<i class='fa fa-caret-left'></i>",
            "<i class='fa fa-caret-right'></i>"
          ],
          autoplay: true,
          autoplayHoverPause: true,
          responsive: {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 }
          }
        });
      });
    });
  }

  /* ---- "VIEW SUSAN'S LABCHARGE OFFER" buttons scroll to the bundle section ---- */
  function initScroll() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('[data-scroll-to="offers"]') : null;
      if (!trigger) return;
      var target = document.querySelector('[data-offers]');
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function start() { initSwiper(); initOwl(); initScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
